import { Button, Card, CardContent, Input, Label } from "@devhop/ui";
import { useEffect, useState } from "react";
import {
  usePrintFeeDefaultsQuery,
  usePutPrintFeeDefaults,
} from "@/modules/cf-feed/presentation/api/queries";
import {
  formatPriceInput,
  maskPriceInput,
  parsePriceInput,
} from "@/modules/cf-feed/presentation/ui/table-helpers";
import { QueryState } from "@/shared/ui/QueryState";

function printFeeLabel(code: string): string {
  if (code === "NAME_PRINT") return "ຊື່ (NAME_PRINT)";
  if (code === "NUMBER_PRINT") return "ໝາຍເລກ (NUMBER_PRINT)";
  return code;
}

export function PrintFeeDefaultsCard() {
  const defaultsQuery = usePrintFeeDefaultsQuery();
  const putDefaults = usePutPrintFeeDefaults();
  const [drafts, setDrafts] = useState<
    Array<{ optionCode: string; fee: string }>
  >([]);

  useEffect(() => {
    const items = defaultsQuery.data?.items;
    if (!items) return;
    setDrafts(
      items.map((i) => ({
        optionCode: i.optionCode,
        fee: formatPriceInput(i.defaultSurchargeLak),
      })),
    );
  }, [defaultsQuery.data?.items]);

  const handleSave = () => {
    putDefaults.mutate(
      drafts.map((d) => ({
        optionCode: d.optionCode,
        defaultSurchargeLak: parsePriceInput(d.fee) ?? 0,
      })),
    );
  };

  return (
    <Card>
      <CardContent className="space-y-4 pt-6">
        <div>
          <h2 className="font-semibold text-base">ຄ່າພິມເລີ່ມຕົ້ນ (ລະບົບ CF)</h2>
          <p className="mt-1 text-muted-foreground text-sm">
            ເກັບໃນ Admin DB — ໃຊ້ເປັນຄ່າເລີ່ມຕົ້ນເມື່ອເປີດຊື່ / ໝາຍເລກໃນໂພສ ຫຼື Live. ໂພສສາມາດ
            override ໄດ້; ອໍເດີເກົ່າໃຊ້ snapshot. ຕັ້ງ 0 = ຟຣີ.
          </p>
        </div>

        <QueryState
          result={defaultsQuery}
          isEmpty={Boolean(defaultsQuery.data && drafts.length === 0)}
          title="ກໍາລັງໂຫຼດຄ່າພິມ"
          description="ອ່ານຈາກ Admin DB"
          variant="inline"
        >
          <div className="grid gap-4 sm:grid-cols-2">
            {drafts.map((d) => (
              <div key={d.optionCode} className="space-y-1.5">
                <Label htmlFor={`print-fee-${d.optionCode}`}>
                  {printFeeLabel(d.optionCode)} (LAK)
                </Label>
                <Input
                  id={`print-fee-${d.optionCode}`}
                  inputMode="numeric"
                  className="tabular-nums"
                  value={d.fee}
                  onChange={(e) =>
                    setDrafts((prev) =>
                      prev.map((row) =>
                        row.optionCode === d.optionCode
                          ? { ...row, fee: maskPriceInput(e.target.value) }
                          : row,
                      ),
                    )
                  }
                />
              </div>
            ))}
          </div>

          <Button
            type="button"
            onClick={handleSave}
            disabled={putDefaults.isPending || drafts.length === 0}
          >
            {putDefaults.isPending ? "ກຳລັງບັນທຶກ..." : "ບັນທຶກ"}
          </Button>
        </QueryState>
      </CardContent>
    </Card>
  );
}
